/**
 * i18n — react-i18next konfiguratsiyasi
 *
 * Kanonik:
 *   - 3 ta til: uz (lotin, default), uz-Cyrl (kirill), ru
 *   - Tanlov localStorage'da 'avtofix.lang' kaliti bilan saqlanadi
 *   - Brauzer tili detect qilinadi (fallback uz)
 *   - Type-safe keys (Translations interface'i orqali)
 */

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { ru } from './locales/ru';
import { uz } from './locales/uz';
import { uzCyrl } from './locales/uzCyrl';

export const SUPPORTED_LANGUAGES = ['uz', 'uz-Cyrl', 'ru'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  uz: "O'zbek (lotin)",
  'uz-Cyrl': 'Ўзбек (кирилл)',
  ru: 'Русский',
};

const STORAGE_KEY = 'avtofix.lang';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      uz: { translation: uz },
      'uz-Cyrl': { translation: uzCyrl },
      ru: { translation: ru },
    },
    fallbackLng: 'uz',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // React allaqachon XSS oldini oladi
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    returnNull: false,
  });

export default i18n;
